import {
  Box,
  Button,
  List,
  ListItem,
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon } from "../../svg";
import {
  BANKI_RU_FIRST_STEP_WARNING,
  BANKI_RU_FIRST_STEP_REQUIREMENTS,
  BANKI_RU_FORM_SUCCESS_REQUIREMENTS,
  BANKI_RU_FORM_SUCCESS_WARNING,
  BANKI_RU_STOP_LIST,
} from "../../forms/ReviewForm/ReviewForm.constants";
import { WarningIcon } from "../../svg/WarningIcon";
import { HTMLText } from "../../forms/ReviewForm/FormStates/SuccessState/FormSuccess.styles";

interface ModalBankiRuProps {
  isOpen: boolean;
  onClose: () => void;
  isFirstStep?: boolean;
}

export function ModalBankiRu({ isOpen, onClose, isFirstStep = false }: ModalBankiRuProps) {
  const requirements = isFirstStep
    ? BANKI_RU_FIRST_STEP_REQUIREMENTS
    : BANKI_RU_FORM_SUCCESS_REQUIREMENTS;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay style={{ background: "#C9C9C94D", backdropFilter: "blur(6px)" }} />
      <ModalContent
        className="relative mx-8 px-3 py-[18px]"
        style={{ marginTop: "22vh", borderRadius: "24px", minWidth: 343 }}
      >
        <button type="button" className="absolute top-1 right-1 outline-0 p-2" onClick={onClose}>
          <CloseIcon stroke="#B7B7B7" width={14} height={14} />
        </button>
        <ModalHeader
          className="mb-5 text-center px-0"
          padding={0}
          fontSize={16}
          fontWeight={500}
          color="text.heading"
        >
          Требования к отзыву Банки.ру
        </ModalHeader>
        <List className="flex flex-col gap-[10px]">
          {requirements.map((requirement) =>
            requirement.type === "checked" ? (
              <ListItem key={requirement.text} className="flex gap-[8px] ">
                <Box
                  className="relative flex justify-center items-center min-w-[25px] h-[25px] border border-[#57BD2C] rounded-full"
                  color="marker.green"
                >
                  <CheckIcon width={8} height={6} fill="#57BD2C" />
                </Box>
                <div className="flex items-center min-h-[25px]">
                  <HTMLText
                    fontSize={12}
                    dangerouslySetInnerHTML={{ __html: requirement.text }}
                    className={"whitespace-pre-line text-[12px] text-[#4C4C4C] "}
                  />
                </div>
              </ListItem>
            ) : (
              <HTMLText
                fontSize={12}
                dangerouslySetInnerHTML={{ __html: requirement.text }}
                className="whitespace-pre-line text-xs text-[#4C4C4C] mt-2 mb-2"
              />
            )
          )}

          {BANKI_RU_STOP_LIST.map((stopItem) => (
            <ListItem key={stopItem} className="flex items-center gap-[8px]">
              <Box className="flex justify-center items-center min-w-[25px] h-[25px] border border-[#F03226] rounded-full">
                <CloseIcon stroke="#F03226" />
              </Box>
              <Text fontSize={12} className="text-xs text-[#4C4C4C]">
                {stopItem}
              </Text>
            </ListItem>
          ))}
          <ListItem key="warning" className="flex items-center gap-[8px]">
            <Box className="flex justify-center items-center min-w-[25px] h-[25px] text-xs">
              <WarningIcon />
            </Box>
            <Text fontSize={12} className="font-medium text-xs text-[#4C4C4C]">
              {isFirstStep ? BANKI_RU_FIRST_STEP_WARNING : BANKI_RU_FORM_SUCCESS_WARNING}
            </Text>
          </ListItem>
        </List>
      </ModalContent>
      <Button onClick={onClose}>X</Button>
    </Modal>
  );
}
